import { User } from '@vision/ui/interfaces';
import { useAppSelector } from './useAppSelector';

export function useUser(): User {
  return useAppSelector((state) => state.AuthState.user);
}
